import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock, Lock } from 'lucide-react';
export function SignUpForm() {
  return <section className="bg-brand-black py-16 md:py-24 relative" data-id="element-183">
      <div className="absolute inset-0 film-grain z-0" data-id="element-184" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-185">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16" data-id="element-186">
          {/* Left Column - Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col justify-center" data-id="element-187">
            <p className="text-brand-lime font-mono font-bold tracking-widest uppercase text-sm mb-4" data-id="element-188">
              Sign Up Today
            </p>
            <h2 className="text-brand-soft text-[44px] md:text-[60px] leading-[0.95] font-display mb-6 uppercase" data-id="element-189">
              Get Your Free Phone or Tablet
            </h2>
            <p className="text-brand-soft/80 text-base md:text-lg mb-10 leading-relaxed font-sans" data-id="element-190">
              Service is subject to a one-time $23 activation fee. Device and
              service are completely free for qualifying households. Fill out
              the form and a Prime Nation specialist will contact you within 24
              hours.
            </p>

            <div className="flex flex-col sm:flex-row gap-6 sm:gap-8" data-id="element-191">
              <div className="flex items-center gap-3" data-id="element-192">
                <ShieldCheck className="text-brand-lime" size={24} data-id="element-193" />
                <span className="font-mono text-sm uppercase tracking-wider text-brand-soft" data-id="element-194">
                  100% Confidential
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-195">
                <Lock className="text-brand-lime" size={24} data-id="element-196" />
                <span className="font-mono text-sm uppercase tracking-wider text-brand-soft" data-id="element-197">
                  No Credit Check
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-198">
                <Clock className="text-brand-lime" size={24} data-id="element-199" />
                <span className="font-mono text-sm uppercase tracking-wider text-brand-soft" data-id="element-200">
                  Same Day Service
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Form */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-offblack border-t-2 border-brand-lime p-6 md:p-8" data-id="element-201">
            <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-202">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-203">
                <div data-id="element-204">
                  <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-205">
                    First Name
                  </label>
                  <input type="text" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-206" />
                </div>
                <div data-id="element-207">
                  <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-208">
                    Last Name
                  </label>
                  <input type="text" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-209" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-210">
                <div data-id="element-211">
                  <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-212">
                    Email
                  </label>
                  <input type="email" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-213" />
                </div>
                <div data-id="element-214">
                  <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-215">
                    Phone Number
                  </label>
                  <input type="tel" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-216" />
                </div>
              </div>

              <div data-id="element-217">
                <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-218">
                  Street Address
                </label>
                <input type="text" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-219" />
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-5" data-id="element-220">
                <div className="sm:col-span-2" data-id="element-221">
                  <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-222">
                    City
                  </label>
                  <input type="text" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-223" />
                </div>
                <div data-id="element-224">
                  <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-225">
                    State
                  </label>
                  <input type="text" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors" required data-id="element-226" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-227">
                <div data-id="element-228">
                  <label className="block text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-229">
                    Date of Birth
                  </label>
                  <input type="date" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors [color-scheme:dark]" required data-id="element-230" />
                </div>
                <div data-id="element-231">
                  <label className="flex items-center gap-1.5 text-[13px] font-mono uppercase tracking-widest text-brand-lime mb-2" data-id="element-232">
                    Last 4 of SSN
                    <Lock size={14} className="text-brand-lime" title="Encrypted securely" data-id="element-233" />
                  </label>
                  <input type="text" maxLength={4} placeholder="XXXX" className="w-full bg-brand-black border border-brand-concrete text-brand-soft px-4 py-3 min-h-[52px] text-base focus:outline-none focus:border-brand-lime transition-colors placeholder:text-brand-concrete" required data-id="element-234" />
                </div>
              </div>

              <div className="space-y-4 pt-6 border-t border-brand-concrete" data-id="element-235">
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-236">
                  <div className="relative flex items-center justify-center mt-0.5" data-id="element-237">
                    <input type="checkbox" className="peer appearance-none w-5 h-5 border border-brand-concrete bg-brand-black checked:bg-brand-lime checked:border-brand-lime transition-colors cursor-pointer" required data-id="element-238" />
                    <svg className="absolute w-3 h-3 text-brand-black pointer-events-none opacity-0 peer-checked:opacity-100" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-239">
                      <path d="M1 5L4.5 8.5L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-240" />
                    </svg>
                  </div>
                  <span className="text-xs text-brand-soft/60 leading-relaxed group-hover:text-brand-soft transition-colors font-sans" data-id="element-241">
                    I agree to receive SMS messages from Prime Nation regarding
                    my application status, appointments, and program updates.
                    Message and data rates may apply. Reply STOP to unsubscribe.
                  </span>
                </label>
                <label className="flex items-start gap-3 cursor-pointer group" data-id="element-242">
                  <div className="relative flex items-center justify-center mt-0.5" data-id="element-243">
                    <input type="checkbox" className="peer appearance-none w-5 h-5 border border-brand-concrete bg-brand-black checked:bg-brand-lime checked:border-brand-lime transition-colors cursor-pointer" required data-id="element-244" />
                    <svg className="absolute w-3 h-3 text-brand-black pointer-events-none opacity-0 peer-checked:opacity-100" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-245">
                      <path d="M1 5L4.5 8.5L13 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-246" />
                    </svg>
                  </div>
                  <span className="text-xs text-brand-soft/60 leading-relaxed group-hover:text-brand-soft transition-colors font-sans" data-id="element-247">
                    I agree to the Privacy Policy and Terms of Use.
                  </span>
                </label>
              </div>

              <button type="submit" className="w-full bg-brand-lime text-brand-black py-4 font-mono font-bold text-sm uppercase tracking-widest hover:bg-white transition-colors min-h-[52px] mt-4 flex items-center justify-center gap-2" data-id="element-248">
                Apply Now <span className="text-lg leading-none" data-id="element-249">→</span>
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}